exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vue-contextmenu-listWrapper{box-shadow:2px 2px 2px #ccc;display:none;position:fixed;z-index:9999;top:0;left:0}.vue-contextmenu-listWrapper .context-menu-list{width:150px;height:32px;border-radius:4px;background:#f3f3f3;text-decoration:none;list-style:none}.vue-contextmenu-listWrapper .context-menu-list button{cursor:pointer;width:100%;height:100%;display:block;outline:0;border:0}.vue-contextmenu-listWrapper .context-menu-list button i,.vue-contextmenu-listWrapper .context-menu-list button span{float:left}.vue-contextmenu-listWrapper .context-menu-list button i{padding:0 10px}.vue-contextmenu-listWrapper .context-menu-list button:hover{box-shadow:0 1px 3px rgba(34,25,25,.2);color:#fff;border-radius:4px;background:linear-gradient(180deg,#5a6a76,#2e3940)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1931f86e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/VueContextMenu.vue
// module id = 3
// module chunks = 0